var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendarDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 22.6562C1.5625 23.9502 2.6123 25 3.90625 25H21.0938C22.3877 25 23.4375 23.9502 23.4375 22.6562V9.375H1.5625V22.6562ZM4.6875 13.2812C4.6875 12.8516 5.03906 12.5 5.46875 12.5H10.1562C10.5859 12.5 10.9375 12.8516 10.9375 13.2812V17.9688C10.9375 18.3984 10.5859 18.75 10.1562 18.75H5.46875C5.03906 18.75 4.6875 18.3984 4.6875 17.9688V13.2812ZM21.0938 3.125H18.75V0.78125C18.75 0.351562 18.3984 0 17.9688 0H16.4062C15.9766 0 15.625 0.351562 15.625 0.78125V3.125H9.375V0.78125C9.375 0.351562 9.02344 0 8.59375 0H7.03125C6.60156 0 6.25 0.351562 6.25 0.78125V3.125H3.90625C2.6123 3.125 1.5625 4.1748 1.5625 5.46875V7.8125H23.4375V5.46875C23.4375 4.1748 22.3877 3.125 21.0938 3.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarDay);
export default __webpack_public_path__ + "static/media/icon-calendar-day.e05966f336c8e102f75791faa2ed51b7.svg";
export { ForwardRef as ReactComponent };